<template>
    <div>
        <header class="Mybar bg_white">
            <div class="myTitle">{{title}}</div>
        </header>
        <main class="MainCon" id="MainCon">
            <div class="h100">
                <div class="mb10">
                    <IScroll @loadBottom="loadMore" ref="scroll" id="scrollWrap">
                        <div class="w50 fl indexColumnBlockBT"
                             :class="{'indexColumnBlockBR': index%2 !== 1}"
                             v-for="(item,index) in list"
                             v-on:click="toShopDetail(item.id)" :key="index">
                            <div class="ml7 mr7 pt10 pb5">
                                <p class="tc" style="line-height: 60px;">
                                    <img :src="item.shop_icon"
                                         @load="autoResizeImage(0,60,$event)" />
                                </p>
                                <p class="shopName">{{item.shop_name}}</p>
                            </div>
                        </div>
                    </IScroll>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import IScroll from '../../components/IScroll';

    export default {
        components: {IScroll},
        props: {
            title: {
                type: String
            },
            styleName: {
                type: String,
                default: 'main'
            },
            list: {
                type: Array
            }
        },
        methods: {
            loadMore: function () {
                this.$emit('loadMore', true);
            },
            autoResizeImage: (maxWidth, maxHeight, event) => {
                let thisImg = event.currentTarget;
                let img = new Image();
                img.src = thisImg.src;
                let hRatio;
                let wRatio;
                let Ratio = 1;
                let w = img.width;
                let h = img.height;
                wRatio = maxWidth / w;
                hRatio = maxHeight / h;
                if (maxWidth === 0 && maxHeight === 0) {
                    Ratio = 1;
                } else if (maxWidth === 0) {//
                    if (hRatio < 1) Ratio = hRatio;
                } else if (maxHeight === 0) {
                    if (wRatio < 1) Ratio = wRatio;
                } else if (wRatio < 1 || hRatio < 1) {
                    Ratio = (wRatio <= hRatio ? wRatio : hRatio);
                }
                if (Ratio < 1) {
                    w = w * Ratio;
                    h = h * Ratio;
                }
                thisImg.height = h;
                thisImg.width = w;
            },
            toShopDetail: function (id) {
                const route = {
                    name: 'shop-detail',
                    query: {
                        id
                    }
                };
                this.$router.push(route);
            }
        }
    }
</script>

<style scoped>

</style>
